<template>
  <v-app>
    <Header :Title="title"/>
    <v-main>
      <Body :Params="Parameters"/>
    </v-main>
    <Footer Title="OUG Portals Platform"/>
  </v-app>
</template>

<script>
import Header from "./components/Header.vue"
import Body from "./Views/Home.vue"
import Footer from "./components/Footer.vue"
import Locations from "./Data/Locations"
// Portals

export default {
  name: "App",
  components: {
    Header,
    Body,
    Footer,
  },
  data: () => ({
    title: "",
    Parameters: {}
  }),
  created() {
    // Set the default theme to Dark
    this.$vuetify.theme.isDark = true
    
    window.zE('webWidget', 'hide');
    let hostname = window.location.hostname
    if (Locations[hostname]) {
      this.Parameters = Locations[hostname]
    } 

    let query = window.location.search.substring(1).split("&");
    for (var i = 0, max = query.length; i < max; i++)
    {
        if (query[i] === "") // check for trailing & with no param
            continue;

        var param = query[i].split("=");
        this.Parameters[decodeURIComponent(param[0])] = decodeURIComponent(param[1] || "");
    }
    this.title = `${this.Parameters.Portal} - Registration Platform`
  },
  methods: {
    
  }
};

</script>
